import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AnalyticsFilters } from '@brand-lolly/app/social-media-influencer/modules/social-listening/models/social-listening-analytics.model';
import { advancedPostToQuery } from '@brand-lolly/app/social-media-influencer/modules/social-listening/components/advanced-filters/advanced-filters.types';
import { SlMatchTypeFilter } from '@brand-lolly/app/social-media-influencer/modules/social-listening/components/filters/match-type/match-type.component';
import { recoverUnlessStrict } from '@brand-lolly/app/social-media-influencer/modules/social-listening/services/recover-unless-strict';
import { smiUrl } from 'components';
import { Observable } from 'rxjs';

export interface WebsiteTrafficDemographics {
	male: number;
	female: number;
	/** Distinct authors whose gender is known: what the two percentages rest on. */
	authors?: number;
}

@Injectable({
	providedIn: 'root'
})
export class GetSocialListeningMyBrandAnalyticsWebsiteTrafficDemographicsService {
	constructor(private http: HttpClient) {}

	// Window params match the other analytics services
	// (brandId, cutoff, filters, to); omitted => backend default (all data).
	fetch(
		brandId: string,
		cutoff?: Date | null,
		filters?: AnalyticsFilters,
		to?: Date | null,
		matchType?: SlMatchTypeFilter,
		strict = false
	): Observable<WebsiteTrafficDemographics> {
		const urlBuilder = smiUrl()
			.add('social-listening')
			.add('brand')
			.add(brandId)
			.add('analytics-website-traffic-demographics')
			.query('from', cutoff?.toISOString())
			.query('to', to?.toISOString());
		this.applyFilters(urlBuilder, filters, matchType);
		const url = urlBuilder.done();

		return this.http
			.get<WebsiteTrafficDemographics>(url)
			.pipe(recoverUnlessStrict(strict, () => ({ male: 0, female: 0 })));
	}

	private applyFilters(
		b: any,
		filters?: AnalyticsFilters,
		matchType?: SlMatchTypeFilter
	): void {
		if (filters?.platforms?.length)
			b.query('platforms', filters.platforms.join(','));
		if (filters?.sentiments?.length)
			b.query('sentiments', filters.sentiments.join(','));
		if (filters?.emotions?.length)
			b.query('emotions', filters.emotions.join(','));
		if (filters?.languages?.length)
			b.query('languages', filters.languages.join(','));
		if (filters?.engagementRate) {
			b.query('engagement_rate_min', String(filters.engagementRate[0]));
			b.query('engagement_rate_max', String(filters.engagementRate[1]));
		}
		if (matchType) b.query('match_type', matchType);
		for (const [advKey, advVal] of Object.entries(
			advancedPostToQuery(filters?.advanced)
		)) {
			b.query(advKey, advVal);
		}
	}
}
